import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const QrCodes = () => {
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [AllQrCodes, setAllQrCodes] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [switchModal, setSwitchModal] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleAdd = () => {
        navigate('/add-qrcode');
        // setShowAddDialog(true);
        // setEditable(false);
        // setViewable(false);
    };

    const handleEdit = (rowData) => {
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };

    const handleInputSwitch = async () => {
        setLoadingBtn(true);
        const data = { isActive: !switchData?.isActive };

        setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };

    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const actionBodyTemplate = (rowData) => (
        <div className="actions">
            <InputSwitch
                tooltip="Status"
                checked={rowData?.isActive}
                onChange={() => {
                    setSwitchData(rowData);
                    handleSwitchModalOpen();
                }}
            />
            <Button icon="pi pi-pencil" tooltip="Edit" className="p-button-rounded p-button-primary mx-2" onClick={() => handleEdit(rowData)} />
            <Button icon="pi pi-eye" tooltip="View" className="p-button-rounded" style={{ backgroundColor: '#F2AC57', border: 'none' }} onClick={() => handleView(rowData)} />
        </div>
    );

    const viewColumnTemplate = () => <Button icon="pi pi-eye" className="p-button-text" />;

    const statusColumnTemplate = (rowData) => <span>{rowData?.status || '-'}</span>;

    return (
        <div className="p-4">
            <h3 className="mb-4">QR CODES</h3>

            <div className="flex justify-content-end align-items-center mb-3">
                <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />
            </div>

            <DataTable
                value={AllQrCodes}
                paginator
                rows={10}
                emptyMessage="No data available in table"
                responsiveLayout="scroll"
                className="p-datatable-sm"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            >
                <Column field="dateTime" header="Date Time" />
                <Column field="title" header="Title" />
                <Column field="referenceId" header="Reference ID" />
                <Column field="type" header="Type" />
                <Column body={viewColumnTemplate} header="View" />
                <Column body={statusColumnTemplate} header="Status" />
                <Column header="Actions" body={actionBodyTemplate} />
            </DataTable>
        </div>
    );
};

export default QrCodes;
